module.exports = __webpack_public_path__ + "static/img/chamber-1.4913bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/chamber-1.png
// module id = E4+8
// module chunks = 12